module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--full-width text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeFilters.apply(null, arguments)
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Se og rediger UV-grænser")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isLoaderModal": true
    }
  }) : [_c('div', {
    staticClass: "uv-limits__toolbar"
  }, [_c('div', {
    staticClass: "uv-limits__filters",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('Tabs', {
    staticClass: "uv-limits__tabs",
    attrs: {
      "tabs": [{
          id: 'all',
          title: 'Alle'
        },
        {
          id: 'with',
          title: 'Med UV-grænse (' + _vm.rowsWithTemplate + ')'
        },
        {
          id: 'without',
          title: 'Uden UV-grænse (' + _vm.rowsWithoutTemplate + ')'
        }
      ],
      "selected": _vm.templateTab
    },
    on: {
      "select": function($event) {
        _vm.templateTab = $event
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "closeFromProp": _vm.closeFiltersCount,
      "numberOfSelectedTagsToShow": 4,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": _vm.clearNames
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.uniqueGroups,
      "selectedTags": _vm.selectedGroups,
      "closeFromProp": _vm.closeFiltersCount,
      "numberOfSelectedTagsToShow": 4,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.toggleGroup,
      "clear": _vm.clearGroups
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Ansættelse',
      "tags": _vm.uniqueEmploymentTitles,
      "selectedTags": _vm.selectedEmploymentTitles,
      "closeFromProp": _vm.closeFiltersCount,
      "numberOfSelectedTagsToShow": 4,
      "placeholder": 'Vælg ansættelser'
    },
    on: {
      "select": _vm.toggleEmploymentTitle,
      "clear": _vm.clearEmploymentTitles
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "uv-limits__bulk-bar"
  }, [_c('div', {
    staticClass: "uv-limits__bulk-bar-left"
  }, [(!_vm.isBulkMode) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": _vm.enableBulkMode
    }
  }, [_vm._v("\n            Tildel stillingskategori til flere\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isBulkMode) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "propOffset": [0, 8],
      "isBottomStart": false,
      "isCloseOnDropdownClick": true,
      "closeFromProp": _vm.closeFiltersCount
    }
  }, [_c('button', {
    staticClass: "do-bttn uv-limits__edit-templates-bttn",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                Rediger stillingskategorier\n                "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('div', {
    staticClass: "uv-limits__templates-dropdown",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('ul', {
    staticClass: "uv-limits__templates-dropdown__list"
  }, [(_vm.employmentTemplates.length === 0) ? _c('li', {
    staticClass: "italic"
  }, [_vm._v("Ingen stillingskategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
    return _c('li', {
      key: template.id,
      staticClass: "uv-limits__templates-dropdown__item",
      on: {
        "click": function($event) {
          return _vm.openEditTemplate(template)
        }
      }
    }, [_c('span', {
      staticClass: "uv-limits__templates-dropdown__item-title"
    }, [_vm._v("\n                      " + _vm._s(template.title) + "\n                      "), _c('span', {
      staticClass: "uv-limits__templates-dropdown__item-limit"
    }, [_vm._v("\n                        UV-grænse: " + _vm._s(template.hour_limit ? template.hour_limit : '—') + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "icon__bg-circle",
      attrs: {
        "title": "Redigér UV-grænse og lønkode"
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "uv-limits__templates-dropdown__create",
    on: {
      "click": _vm.openCreateTemplate
    }
  }, [_c('div', {
    staticClass: "btn-trans"
  }, [_vm._v("\n                    Opret stillingskategori\n                  ")])])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBulkMode) ? _c('p', {
    staticClass: "text-explainer uv-limits__explainer"
  }, [_vm._v("\n            UV-grænser og lønkoder sættes på stillingskategorierne. UV-timer vises fra tildelt undervisning.\n          ")]) : [_c('span', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.selectedCount) + " valgt")]), _vm._v(" "), (_vm.selectedCount > 0) ? _c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "propOffset": [0, 8],
      "isBottomStart": true,
      "isCloseOnDropdownClick": true,
      "closeFromProp": _vm.closeFiltersCount
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn--submit uv-limits__bulk-submit-bttn",
    class: {
      'do-bttn--submit--loading': _vm.isSavingBulkTemplates
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n                Vælg stillingskategori til " + _vm._s(_vm.selectedCount) + " "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.employmentTemplates.length === 0) ? _c('li', {
    staticClass: "italic"
  }, [_vm._v("Ingen stillingskategorier oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
    return _c('li', {
      key: template.id,
      on: {
        "click": function($event) {
          return _vm.assignTemplateToSelected(template)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
  })], 2)])], 1) : _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'top',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n                arrow: true,\n                placement: 'top',\n                animateFill: false,\n                animation: 'shift-away',\n                boundary: 'window',\n                zIndex: 12312312312312\n              }"
    }],
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled uv-limits__bulk-submit-bttn",
    attrs: {
      "content": "Vælg personer først"
    }
  }, [_vm._v("\n              Vælg stillingskategori til de valgte "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.disableBulkMode
    }
  }, [_vm._v("\n              Annuller\n            ")])]], 2), _vm._v(" "), (_vm.tidsbegraensetCount > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        zIndex: 12312312312312
      }),
      expression: "{\n            arrow: true,\n            placement: 'bottom',\n            animateFill: false,\n            animation: 'shift-away',\n            boundary: 'window',\n            zIndex: 12312312312312\n          }"
    }],
    staticClass: "do-badge do-badge--yellow",
    attrs: {
      "content": _vm.tidsbegraensetCount + (_vm.tidsbegraensetCount === 1 ? ' ansættelse har' : ' ansættelser har') + ' en afvigende periode med UV-timer. Klik på \'Beregn timer\' for at danne et UV-tillæg for perioden.'
    }
  }, [_c('span', {
    staticClass: "icon-warning"
  }), _vm._v("\n          " + _vm._s(_vm.tidsbegraensetCount) + " " + _vm._s(_vm.tidsbegraensetCount === 1 ? 'ansættelse' : 'ansættelser') + " med afvigende periode\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uv-limits__table-scroll"
  }, [_c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [(_vm.isBulkMode) ? _c('th', {
    staticClass: "uv-limits__select-cell",
    on: {
      "click": _vm.toggleAllVisibleEmployments
    }
  }, [_c('div', {
    staticClass: "do-checkbox",
    class: {
      'do-checkbox--selected': _vm.areAllVisibleEmploymentsSelected
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")]), _vm._v(" "), _c('th', [_vm._v("UV-grænse")]), _vm._v(" "), _c('th', [_vm._v("Lønkode")]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('th', [_vm._v("Spec-skole lønkode")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "uv-limits__narrow uv-limits__sortable",
    class: {
      'uv-limits__sortable--active': _vm.uvHoursSort
    },
    on: {
      "click": _vm.toggleUvHoursSort
    }
  }, [_vm._v("\n              UV-timer\n              "), _c('span', {
    staticClass: "icon-menu-open uv-limits__sort-icon",
    class: {
      'uv-limits__sort-icon--asc': _vm.uvHoursSort === 'asc',
      'uv-limits__sort-icon--muted': !_vm.uvHoursSort
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('th', [_vm._v("Ansættelsesnummer")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "uv-limits__narrow"
  }, [_vm._v("Lønbrøk")]), _vm._v(" "), _c('th', {
    staticClass: "uv-limits__narrow"
  }, [_vm._v("Bruttotid")]), _vm._v(" "), _c('th', [_vm._v("Startdato")]), _vm._v(" "), _c('th', [_vm._v("Slutdato")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [(_vm.filteredRows.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.emptyColspan
    }
  }, [_c('i', [_vm._v("Ingen personer matcher filtrene")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', {
      key: row.key,
      class: {
        'uv-limits__row--selectable': _vm.isBulkMode && _vm.isSelectableRow(row),
        'is-selected': _vm.isBulkMode && _vm.isRowSelected(row),
        'uv-limits__row--inactive': !row.employment && _vm.isSalaryIntegrationActive
      },
      on: {
        "click": function($event) {
          _vm.isBulkMode && _vm.toggleRow(row)
        }
      }
    }, [(_vm.isBulkMode) ? _c('td', {
      staticClass: "uv-limits__select-cell"
    }, [(row.employment) ? _c('div', {
      staticClass: "do-checkbox",
      class: {
        'do-checkbox--selected': _vm.isEmploymentSelected(row.employment.id)
      }
    }) : _vm._e(), _vm._v(" "), (!row.employment && !_vm.isSalaryIntegrationActive) ? _c('div', {
      staticClass: "do-checkbox",
      class: {
        'do-checkbox--selected': _vm.isUserWithoutEmploymentSelected(row.user.id)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(row.user.name))]), _vm._v(" "), (_vm.hasDataIssues(row.user.id)) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'right',
          animateFill: false,
          animation: 'shift-away',
          boundary: 'window',
          zIndex: 12312312312312
        }),
        expression: "{\n                  arrow: true,\n                  placement: 'right',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312\n                }"
      }],
      staticClass: "uv-limits__warning",
      attrs: {
        "content": _vm.dataIssuesTitle(row.user.id)
      }
    }, [_c('span', {
      staticClass: "icon-warning"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "uv-limits__template-cell"
    }, [(row.employment) ? _c('select', {
      staticClass: "do-select width-100",
      domProps: {
        "value": row.employment.employment_template_id || ''
      },
      on: {
        "change": function($event) {
          return _vm.setEmploymentTemplate(row.employment, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
      return _c('option', {
        key: template.id,
        domProps: {
          "value": template.id
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
    })], 2) : (!_vm.isSalaryIntegrationActive) ? _c('select', {
      staticClass: "do-select width-100",
      on: {
        "change": function($event) {
          return _vm.createEmploymentForUser(row.user, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
      return _c('option', {
        key: template.id,
        domProps: {
          "value": template.id
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
    })], 2) : _c('span', {
      staticClass: "muted"
    }, [_vm._v("—")])]), _vm._v(" "), (row.employment && row.isLastForUser && !_vm.isSalaryIntegrationActive) ? _c('div', {
      staticClass: "uv-limits__add-employment"
    }, [(_vm.addingForRowKey === row.key) ? _c('select', {
      staticClass: "do-select width-100",
      on: {
        "change": function($event) {
          _vm.createEmploymentForUser(row.user, $event.target.value);
          _vm.addingForRowKey = null
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": "",
        "value": ""
      }
    }, [_vm._v("Vælg stillingskategori")]), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(template) {
      return _c('option', {
        key: template.id,
        domProps: {
          "value": template.id
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.templateOptionLabel(template)) + "\n                  ")])
    })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.template && row.template.hour_limit ? row.template.hour_limit : '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.template && row.template.hour_limit_salary_code_id ? _vm.salaryCodeLoenart(row.template.hour_limit_salary_code_id) : '—'))]), _vm._v(" "), (_vm.showSpecialSkoleSalaryCodeColumn) ? _c('td', [_vm._v(_vm._s(row.template && row.template.special_hour_limit_salary_code_id ? _vm.salaryCodeTitle(row.template.special_hour_limit_salary_code_id) : '—'))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__narrow"
    }, [_vm._v(_vm._s(_vm.formatDecimal(_vm.assignedTeachingHours(row.user.id))))]), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__secondary"
    }, [_vm._v(_vm._s(row.employment ? _vm.employmentTitle(row.employment) : 'Ingen aktive ansættelser'))]), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
      staticClass: "uv-limits__secondary"
    }, [_vm._v(_vm._s(row.employment && row.employment.employment_number ? row.employment.employment_number : '—'))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__narrow uv-limits__secondary",
      class: {
        'uv-limits__missing': _vm.ansaettelsesgradIssue(row.user.id)
      }
    }, [(_vm.ansaettelsesgradIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDecimal(_vm.weeklyHours(row.user.id))))]], 2), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__narrow uv-limits__secondary",
      class: {
        'uv-limits__missing': _vm.bruttotidIssue(row.user.id)
      }
    }, [(_vm.bruttotidIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDecimal(_vm.bruttoTime(row.user.id))))]], 2), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__secondary",
      class: {
        'uv-limits__missing': _vm.startDateIssue(row.user.id),
        'uv-limits__deviant': _vm.isTidsbegraensetRow(row) && _vm.startIsDeviant(row)
      }
    }, [(_vm.startDateIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDate(_vm.periodStart(row.user.id))))]], 2), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__secondary",
      class: {
        'uv-limits__missing': _vm.endDateIssue(row.user.id),
        'uv-limits__deviant': _vm.isTidsbegraensetRow(row) && _vm.endIsDeviant(row)
      }
    }, [(_vm.endDateIssue(row.user.id)) ? [_vm._v("Mangler")] : [_vm._v(_vm._s(_vm.formatDate(_vm.periodEnd(row.user.id))))]], 2), _vm._v(" "), _c('td', {
      staticClass: "uv-limits__actions-cell",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.isTidsbegraensetRow(row)) ? _c('button', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          placement: 'left',
          animateFill: false,
          animation: 'shift-away',
          boundary: 'window',
          zIndex: 12312312312312
        }),
        expression: "{\n                  arrow: true,\n                  placement: 'left',\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  zIndex: 12312312312312\n                }"
      }],
      staticClass: "do-bttn uv-limits__beregn-bttn",
      attrs: {
        "content": "Afvigende periode (ikke 1/8 – 31/7). Beregn UV-tillæg for den faktiske periode og dan et supplement i listen."
      },
      on: {
        "click": function($event) {
          return _vm.openBeregn(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-warning"
    }), _vm._v(" Beregn timer\n              ")]) : _vm._e()])])
  })], 2)])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Luk")])]), _vm._v(" "), (_vm.isTemplateModalOpen) ? _c('DoEmploymentTemplate', {
    attrs: {
      "theEditEmploymentTemplate": _vm.editTemplate,
      "forceHourLimitMode": true
    },
    on: {
      "created": _vm.onTemplateSaved,
      "updated": _vm.onTemplateSaved,
      "close": _vm.closeTemplateModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.beregnRow) ? _c('UvLimitTidsbegraensetModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId,
      "userId": _vm.beregnRow.user.id,
      "userName": _vm.beregnRow.user.name,
      "employmentId": _vm.beregnRow.employment.id,
      "ansaettelsesgradPercent": _vm.employmentPercentage(_vm.beregnRow.user.id),
      "yearNormHours": _vm.bruttoTime(_vm.beregnRow.user.id),
      "periodStart": _vm.periodStart(_vm.beregnRow.user.id),
      "periodEnd": _vm.periodEnd(_vm.beregnRow.user.id),
      "assignedTeachingHours": _vm.assignedTeachingHours(_vm.beregnRow.user.id),
      "initialGraense": _vm.beregnRow.template ? _vm.beregnRow.template.hour_limit : null,
      "salaryCodeId": _vm.beregnRow.template ? _vm.beregnRow.template.hour_limit_salary_code_id : null
    },
    on: {
      "created": _vm.onBeregnCreated,
      "close": function($event) {
        _vm.beregnRow = null
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aa78638!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/UvLimitsModal.vue
// module id = 1903
// module chunks = 1